import readMore from "./javascript/read-more"
import countdown from "./javascript/countdown"
import "./styles/application.scss"

export default function () {
  readMore()
  countdown()
}
